module.exports = __webpack_public_path__ + "cc72a2ea8579574085db994a61866358.png";